<div class="root">
    @if (clients$ | async; as clients) {
        @for (client of clients; track client) {
            <div>
                <div class="outer" [class.active]="client.id === (siteConfig$ | async)?.client_id">
                    <frog-workspace-button
                        [siteConfig]="client.config"
                        (clicked)="setClient($event)"
                    ></frog-workspace-button>
                </div>
            </div>
        }
    }
    <button
        mat-icon-button
        matTooltip="Create new Workspace"
        matTooltipPosition="right"
        routerLink="/get-started/create"
    >
        <mat-icon>add</mat-icon>
    </button>
</div>
